import Reveal from "@/components/Reveal";

const SectionHeading = ({ overline, title, dark = false, align = "left" }) => (
  <Reveal className={align === "center" ? "text-center" : "text-left"}>
    <div className={`flex items-baseline gap-4 ${align === "center" ? "justify-center" : ""}`}>
      <span className={`text-xs tracking-[0.35em] uppercase font-medium ${dark ? "text-mint" : "text-teal/70"}`}>
        {overline}
      </span>
    </div>
    <h2 className={`font-display font-bold tracking-tight leading-[0.95] text-4xl sm:text-5xl lg:text-6xl mt-4 ${dark ? "text-cream" : "text-teal"}`}>
      {title}
    </h2>
    <div className={`mt-6 h-px w-24 bg-gold ${align === "center" ? "mx-auto" : ""}`} />
  </Reveal>
);

export default SectionHeading;
